<template>
    <div class="open-or-close">
        <p class="text">打开或者关闭首页按钮</p>
        <a-switch v-model="checkIs" @change="onChange" />
    </div>
</template>
<script>
    export default {
        data() {
            return {
                checkIs:false
            }
        },
        methods: {
            onChange(){
                let self=this;
                self.$http({
                    url:'manager/config/set',
                    method: 'post',
                    data: {
                        type:1
                    }
                }).then(res => {
                    if(res.data.configValue*1===1){
                        self.checkIs=false;
                    }else{
                        self.checkIs=true;
                    }
                })
            },
        },
        created() {
        },
    }
</script>
<style lang=""></style>